function keysFromItems(items) {
  if (items.length < 1)
    return [];
  const keys = Object.keys(items[0]);
  return keys;
}

export { keysFromItems };
//# sourceMappingURL=keysFromItems.js.map
